import React from "react";
import {Config} from '../Config';
import * as Utils from '../inc/Utils';
import {NavLink, useNavigate, useParams} from "react-router-dom";
import toast, {Toaster} from "react-hot-toast";
import moment from "moment-timezone";
import MemberSidebar from "../inc/MemberSidebar";
import {confirmAlert} from "react-confirm-alert";
import 'react-confirm-alert/src/react-confirm-alert.css';
import MD5 from "crypto-js/md5";
import iconDelete from "../img/icons/icon-trash.svg";
import iconPencil from "../img/icons/icon-pencil.svg";
import iconTrash from "../img/icons/icon-trash.svg";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export default function ProposalProperty(prop) {
    let proposalId = prop.proposalId;
    let member = prop.member;
    let readOnly = prop.readOnly;

    //Property
    let refPropertyType = React.useRef();
    let refPropertyProgress = React.useRef();
    let refPropertyIssueNo = React.useRef();
    let refPropertySubject = React.useRef();
    let [showFormProperty, setShowFormProperty] = React.useState(false);
    let [propertyList, setPropertyList] = React.useState(null);
    let [propertyEditId, setPropertyEditId] = React.useState(null);
    let [issueDate, setIssueDate] = React.useState(null);

    React.useEffect(() => {

        (async function() {
            try {
                const proRes = await getPropertyList();
                setPropertyList(proRes);
            } catch (e) {
                //
            }
        })();
    }, []);

    //ProposalProperty
    const onChangeDate = async (value) => {
        setIssueDate(value);
    };
    const onPropertyAdd = () => {
        refPropertyType.current.value = '';
        refPropertyProgress.current.value = '';
        refPropertyIssueNo.current.value = '';
        refPropertySubject.current.value = '';
        setIssueDate(null);
        setShowFormProperty(true);
        setPropertyEditId(null);
    };
    const onPropertyCancel = () => {
        setShowFormProperty(false);
    };
    const onPropertyEdit = async (id) => {
        const result = await getPropertyListView(id);
        if(result) {
            setPropertyEditId(id);
            setShowFormProperty(true);
            refPropertyType.current.value = result.typeName;
            refPropertyProgress.current.value = result.progress;
            refPropertyIssueNo.current.value = result.issueNo;
            setIssueDate(new Date(result.issueDate));
            refPropertySubject.current.value = result.subject;
        }
    };
    const onPropertySubmit = () => {
        let typeName = refPropertyType.current.value;
        let progress = refPropertyProgress.current.value;
        let issueNo = refPropertyIssueNo.current.value;
        let subject = refPropertySubject.current.value;

        if(typeName === '') {
            toast.error(prop.lang === 'en' ? 'Please specify Type':'กรุณาระบุ ประเภททรัพย์สิน');
            refPropertyType.current.focus();
        }
        else if(progress === '') {
            toast.error(prop.lang === 'en' ? 'Please specify Progress':'กรุณาระบุ สถานะดำเนินงาน');
            refPropertyProgress.current.focus();
        }
        else if(issueNo === '') {
            toast.error(prop.lang === 'en' ? 'Please specify Issue No':'กรุณาระบุ เลขที่');
            refPropertyIssueNo.current.focus();
        }
        else if(issueDate === '') {
            toast.error(prop.lang === 'en' ? 'Please specify Issue Date':'กรุณาระบุ วันที่ออก');
        }
        else if(subject === '') {
            toast.error(prop.lang === 'en' ? 'Please specify Subject':'กรุณาระบุ เรื่อง');
            refPropertySubject.current.focus();
        }
        else {
            confirmAlert({
                title: 'แจ้งเตือน',
                message: 'ต้องการบันทึกข้อมูล ?',
                buttons: [
                    {
                        label: 'ตกลง',
                        onClick: async () => {
                            let param = {
                                id: propertyEditId,
                                proposalId: proposalId,
                                typeName: typeName,
                                progress: progress,
                                issueNo: issueNo,
                                issueDate: issueDate,
                                subject: subject,
                                createdBy: -1,
                                createdAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
                                updatedBy: -1,
                                updatedAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss')
                            };
                            const result = await createProperty(param);

                            if(result) {
                                if(result.status === 'success') {

                                    refPropertyType.current.value = '';
                                    refPropertyProgress.current.value = '';
                                    refPropertyIssueNo.current.value = '';
                                    refPropertySubject.current.value = '';
                                    setIssueDate(null);

                                    toast.success(prop.lang === 'en' ? 'Add Intellectual property successfully.':'บันทึกส่วนข้อมูลทรัพย์สินทางปัญญา เรียบร้อย');
                                    setShowFormProperty(false);
                                    const teamRes = await getPropertyList();
                                    setPropertyList(teamRes);
                                }
                                else {
                                    toast.error(prop.lang === 'en' ? 'Sorry, there is a problem. Please contact the administrator':'ขออภัยมีเหตุขัดข้อง กรุณาติดต่อผู้่ดูแลระบบ');
                                }
                            }
                            else {
                                toast.error(prop.lang === 'en' ? 'Sorry, Service is not available at this time. Please contact the administrator.':'ขออภัย ทำรายการได้ในขณะนี้ กรุณาติดต่อผู้่ดูแลระบบ');
                            }
                        }
                    },
                    {
                        label: 'ยกเลิก',
                        onClick: () => {}
                    }
                ]
            });
        }
    };
    const onPropertyDelete = (id) => {
        confirmAlert({
            title: 'แจ้งเตือน',
            message: 'ต้องการบันทึกข้อมูล ?',
            buttons: [
                {
                    label: 'ตกลง',
                    onClick: async () => {
                        const result = await deleteProperty(id);
                        if(result) {
                            if(result.status === 'success') {
                                toast.success(prop.lang === 'en' ? 'Delete successfully.':'ลบข้อมูล เรียบร้อย');
                                setShowFormProperty(false);
                                const teamRes = await getPropertyList();
                                setPropertyList(teamRes);
                            }
                            else {
                                toast.error(prop.lang === 'en' ? 'Sorry, there is a problem. Please contact the administrator':'ขออภัยมีเหตุขัดข้อง กรุณาติดต่อผู้่ดูแลระบบ');
                            }
                        }
                        else {
                            toast.error(prop.lang === 'en' ? 'Sorry, Service is not available at this time. Please contact the administrator.':'ขออภัย ทำรายการได้ในขณะนี้ กรุณาติดต่อผู้่ดูแลระบบ');
                        }
                    }
                },
                {
                    label: 'ยกเลิก',
                    onClick: () => {}
                }
            ]
        });
    };

    async function createProperty(param) {
        const response = await fetch(Config.apiUrl +'/proposalProperty/' + (propertyEditId ? 'updateProperty':'createProperty'), {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': member.accessToken
            },
            body: JSON.stringify(param)
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getPropertyList() {
        const response = await fetch(Config.apiUrl +'/proposalProperty/list', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': member.accessToken
            },
            body: JSON.stringify({
                proposalId: proposalId
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getPropertyListView(id) {
        const response = await fetch(Config.apiUrl +'/proposalProperty/viewProperty', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': member.accessToken
            },
            body: JSON.stringify({
                id: id
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function deleteProperty(id) {
        const response = await fetch(Config.apiUrl +'/proposalProperty/deleteProperty', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': member.accessToken
            },
            body: JSON.stringify({
                id: id
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    return (
        <>
            <div className="mt-3 ps-3">
                <div className="d-flex justify-content-between gap-3">
                    <h6 className="pt-1">{prop.lang === 'en' ? 'Details of related intellectual property':'รายละเอียดทรัพย์สินทางปัญญาที่เกี่ยวข้อง'}</h6>
                    {
                        readOnly ? '' : <button className="btn btn-xs btn-light-2" onClick={onPropertyAdd}>
                            {prop.lang === 'en' ? '+ Add New':'+ เพิ่มรายการ'}
                        </button>
                    }
                </div>
                <div className="table-responsive mt-3">
                    <table className="table table-info table-hover text-center" style={{whiteSpace: 'nowrap'}}>
                        <thead>
                        <tr>
                            <th className="text-center">
                                {prop.lang === 'en' ? 'Type':<>ประเภท<br />ทรัพย์สินทางปัญญา</>}
                            </th>
                            <th className="text-center">
                                {prop.lang === 'en' ? 'Status':<>สถานะ<br />การดำเนินงาน</>}
                            </th>
                            <th className="text-center">{prop.lang === 'en' ? 'Issue No':'เลขที่'}</th>
                            <th className="text-center">{prop.lang === 'en' ? 'Issue Date':'วันที่ออก'}</th>
                            <th className="text-center">{prop.lang === 'en' ? 'Subject':'เรื่อง'}</th>
                            {
                                readOnly ? '' : <th style={{width: '100px'}}>แก้ไข</th>
                            }
                        </tr>
                        </thead>
                        <tbody>
                        {
                            propertyList !== null && propertyList.count > 0 ?
                                propertyList.rows.map((row, index) => {
                                    return (
                                        <tr key={index}>
                                            <td className="text-center">{row.typeName}</td>
                                            <td className="text-center">{row.progress}</td>
                                            <td className="text-center">{row.issueNo}</td>
                                            <td className="text-center">{Utils.dateTimeYMD(row.issueDate)}</td>
                                            <td className="text-center">{row.subject}</td>
                                            {
                                                readOnly ? '' : <td>
                                                    <div className="d-flex justify-content-center gap-2">
                                                        <button className="btn btn-trans" onClick={e => onPropertyEdit(row.id)}>
                                                            <img className="icons svg-js trash" src={iconPencil} alt="" />
                                                        </button>
                                                        <button className="btn btn-trans" onClick={e => onPropertyDelete(row.id)}>
                                                            <img className="icons svg-js trash" src={iconTrash} alt="" />
                                                        </button>
                                                    </div>
                                                </td>
                                            }
                                        </tr>
                                    )
                                }) : <tr><td colSpan={5}>-</td></tr>
                        }
                        </tbody>
                    </table>
                </div>

                <div className={"row g-3 mt-2" + (showFormProperty ? '':' d-none')}>
                    <div className="col-xl-4 col-md-6">
                        <div className="form-group">
                            <h6>{prop.lang === 'en' ? 'Type':'ประเภท ทรัพย์สินทางปัญญา'} <span className="star">*</span></h6>
                            <input type="text" className="form-control" ref={refPropertyType} maxLength={250} />
                        </div>
                    </div>
                    <div className="col-xl-4 col-md-6">
                        <div className="form-group">
                            <h6>{prop.lang === 'en' ? 'Status':'สถานะ การดำเนินงาน'} <span className="star">*</span></h6>
                            <input type="text" className="form-control" ref={refPropertyProgress} maxLength={250} />
                        </div>
                    </div>
                    <div className="col-xl-4 col-md-6">
                        <div className="form-group">
                            <h6>{prop.lang === 'en' ? 'Issue No':'เลขที่'} <span className="star">*</span></h6>
                            <input type="text" className="form-control" ref={refPropertyIssueNo} maxLength={250} />
                        </div>
                    </div>

                    <div className="col-xl-4 col-md-6">
                        <div className="form-group">
                            <h6>{prop.lang === 'en' ? 'Issue Date':'วันที่ออก'} <span className="star">*</span></h6>
                            <DatePicker
                                selected={issueDate}
                                onChange={(date) => onChangeDate(date)}
                                dateFormat="yyyy-MM-dd"
                                wrapperClassName="w-100"
                                className="form-control" />
                        </div>
                    </div>
                    <div className="col-xl-8 col-md-6">
                        <div className="form-group">
                            <h6>{prop.lang === 'en' ? 'Subject':'เรื่อง'} <span className="star">*</span></h6>
                            <input type="text" className="form-control" ref={refPropertySubject} maxLength={250} />
                        </div>
                    </div>

                    <div className="col-12">
                        <div className="buttons gap-15 py-0">
                            <button className="btn btn-xs btn-green" type="button" onClick={onPropertySubmit}>
                                {prop.lang === 'en' ? 'Save':'บันทึก'}
                            </button>
                            <button className="btn btn-xs btn-gray me-auto" type="button" onClick={onPropertyCancel}>
                                {prop.lang === 'en' ? 'Cancel':'ยกเลิก'}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
} 